import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IUserTaskStateDto } from '@nimbus-library/features/user-state/models/user-task-state.model';
import { IUserResponsibilityProfile } from '@nimbus-library/features/user-state/models/user-responsibility-profile.model';
import { ApiRoutes } from '../../models/routes/api-routes';

@Injectable({ providedIn: 'root' })
export class UserStateApiClient {
  public constructor(private readonly baseHttpService: BaseHttpService) {}

  public getUserTaskState(userId: string): Observable<IUserTaskStateDto> {
    return this.baseHttpService.get(ApiRoutes.userState.getUserTaskState(userId));
  }

  public getUserResponsibilityProfiles(userId: string): Observable<IUserResponsibilityProfile[]> {
    return this.baseHttpService.get(ApiRoutes.responsibilityProfile.getUserResponsibilityProfiles(userId));
  }

  public activateUserResponsibilityProfile(userId: string, responsibilityProfileId: string): Observable<void> {
    return this.baseHttpService.put(ApiRoutes.responsibilityProfile.activateUserResponsibilityProfile(userId, responsibilityProfileId));
  }
}
